import { IncentiveLifecycleStatus } from '@varo/graphql-schema-types';

export enum IncentiveDestination {
  Intro = 'INTRO',
  Tracker = 'TRACKER',
  Winner = 'WINNER',
  NotAvailable = 'NOT_AVAILABLE',
}

export const resolveIncentiveScreen = (
  status: IncentiveLifecycleStatus,
  hasMetPrerequisite: boolean,
): IncentiveDestination => {
  switch (status) {
    case IncentiveLifecycleStatus.Targeted:
    case IncentiveLifecycleStatus.Eligible:
      return IncentiveDestination.Intro;
    case IncentiveLifecycleStatus.OptInPendingEligibility:
      return hasMetPrerequisite
        ? IncentiveDestination.Tracker
        : IncentiveDestination.Intro;
    case IncentiveLifecycleStatus.Enrolled:
    case IncentiveLifecycleStatus.InProgress:
      return IncentiveDestination.Tracker;
    case IncentiveLifecycleStatus.Qualified:
      return IncentiveDestination.Winner;
    default:
      return IncentiveDestination.NotAvailable;
  }
};
